import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

const ICONS = {
  info: (
    <span style={{ color: "#007bff", fontSize: 24, marginRight: 12 }}>
      <i className="fa fa-info-circle" />
    </span>
  ),
  warning: (
    <span style={{ color: "#ffc107", fontSize: 24, marginRight: 12 }}>
      <i className="fa fa-exclamation-triangle" />
    </span>
  ),
  danger: (
    <span style={{ color: "#dc3545", fontSize: 24, marginRight: 12 }}>
      <i className="fa fa-times-circle" />
    </span>
  ),
  success: (
    <span style={{ color: "#28a745", fontSize: 24, marginRight: 12 }}>
      <i className="fa fa-check-circle" />
    </span>
  ),
};

const CSHMessage = ({
  isOpen,
  message,
  title = "ClearStone Hub",
  onClose,
  onYes,
  onNo,
  type = "info", // "info" (OK) or "question" (Yes/No)
  messageType = "info" // "info", "warning", "danger", "success"
}) => (
  <Modal isOpen={isOpen} toggle={onClose} centered>
    {title && <ModalHeader toggle={onClose}>{title}</ModalHeader>}
    <ModalBody style={{ display: "flex", alignItems: "center" }}>
      {ICONS[messageType] || null}
      <div style={{ whiteSpace: "pre-line", flex: 1 }}>{message}</div>
    </ModalBody>
    <ModalFooter>
      {type === "question" ? (
        <>
          <Button color="primary" onClick={onYes}>Yes</Button>
          <Button color="secondary" onClick={onNo}>No</Button>
        </>
      ) : (
        <Button color="primary" onClick={onClose}>OK</Button>
      )}
    </ModalFooter>
  </Modal>
);

export default CSHMessage;